import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName } from "../../../../../components/Converter";
import KiloNewton from "../../../../../components/Math/Units/Metric/KiloNewton";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../components/ToolTip";
import { decimalSeparator, thousandSeparator } from "../../../../../i18n";
import {
  selectSchwingungsUntergrenze,
  setSchwingungsUntergrenze,
} from "../../../../../store/slices/innereSlice";

function SchwingungsUntergrenze() {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const schwingungsUntergrenze = useSelector(selectSchwingungsUntergrenze);

  return (
    <RowBody
      titleValue={<p>{t("inner.fatigue.lowerLimit")}</p>}
      indicesValue={
        <span>
          F<sub>k,U</sub>
        </span>
      }
      formulaValue={
        <ToolTip
          id={"SchwingungsUntergrenze"}
          type={IconType.INFO}
          text={t("inner.fatigue.lowerLimit_InfoText")}
        />
      }
      inputValue={
        <NumberFormat
          className={getClassName(schwingungsUntergrenze)}
          value={schwingungsUntergrenze}
          decimalSeparator={decimalSeparator()}
          thousandSeparator={thousandSeparator()}
          displayType="input"
          type="text"
          onValueChange={(value) => dispatch(setSchwingungsUntergrenze(value.floatValue))}
          allowNegative={true}
        />
      }
      unitValue={<KiloNewton />}
    />
  );
}

export default SchwingungsUntergrenze;
